<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{
          tipoMovimiento === "cobro" ? "Nuevo Cobro" : "Nuevo Pago"
        }}</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row v-if="idTurno > 0">
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Nuevo Cobro</h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="fechaCobro"
                :value="fechaCobro"
                label="Fecha Cobro *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="profsBuscar"
                item-text="nombre"
                item-value="idCancha"
                menu-props="auto"
                label="Cancha *"
                hide-details
                prepend-icon="mdi-account"
                v-model="prof"
                :disabled="idTurno > 0"
                dense
                ref="profsBuscar"
                no-data-text="No hay canchas registradas"
              ></v-select>
            </v-col>
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="paciente"
                prepend-icon="mdi-account"
                :rules="requiredRules"
                label="Concepto / Descripción *"
                :disabled="idTurno > 0"
                dense
                @change="idPaciente = null"
                maxlength="150"
                :hint="
                  tipoMovimiento === 'cobro'
                    ? 'Puede buscar un jugador existente apretando la lupa'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="2" class="d-flex">
              <v-btn
                v-show="!(idTurno > 0) && tipoMovimiento === 'cobro'"
                color="primary"
                @click="buscarPaciente"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="observaciones"
                prepend-icon="mdi-account"
                label="Observaciones"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" v-if="tipoMovimiento === 'cobro'">
              <v-select
                :items="formasPago"
                item-text="nombreFormaPago"
                item-value="idFormaPago"
                menu-props="auto"
                label="Forma de Pago *"
                hide-details
                prepend-icon="mdi-currency-usd"
                v-model="formaPago"
                dense
                no-data-text="No hay Formas de Pago configuradas"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="2"
              class="checkbox"
              v-if="tipoMovimiento === 'cobro'"
            >
              <v-checkbox
                v-model="esSena"
                label="Es Seña"
                color="primary"
                dense
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="total"
                prepend-icon="mdi-currency-usd"
                :rules="
                  tipoMovimiento === 'cobro'
                    ? totalRulesCobros
                    : totalRulesPagos
                "
                label="Importe *"
                @blur="toFixed"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn color="success" :disabled="!valid" @click.stop="guardarCobro"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-form>
      <v-card-text v-if="idTurno > 0">
        <v-row dense>
          <v-col cols="12">
            <v-chip class="ma-0" label color="transparent" text-color="black">
              <h3>Cobros ya realizados para este turno</h3>
            </v-chip>
          </v-col>
        </v-row>

        <v-data-table
          v-if="listaCobros.length"
          :headers="headers"
          :items="this.listaCobros"
          class="elevation-1"
          :hide-default-footer="true"
          locale="es-ar"
          item-key="idCrobro"
          :items-per-page="10000"
          ref="myTable"
          :disable-sort="true"
        >
          <template v-slot:item.estado="{ item }">
            <v-chip :color="getColor(item.estado)" dark>
              {{ item.estado }}
            </v-chip>
          </template>
          <template v-slot:item.esSena="{ item }">
            <v-simple-checkbox
              v-model="item.esSena"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="purple"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="editarCobro(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar Cobro</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  class="mr-3"
                  color="red"
                  v-bind="attrs"
                  @click="borrarCobro(item)"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Eliminar Cobro</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  class="mr-3"
                  color="indigo"
                  v-bind="attrs"
                  @click="
                    imprimirCobro(
                      item,
                      pacienteTurno,
                      $store.state.usuario.institucion.nombreInstitucion
                    )
                  "
                  >mdi-file-pdf-box</v-icon
                >
              </template>
              <span>Generar Comprobante</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="
                    item.nombreFormaPago == 'Mercado Pago' &&
                    item.estado == 'Pendiente'
                  "
                  medium
                  class="mr-3"
                  v-on="on"
                  color="blue"
                  v-bind="attrs"
                  @click="generarPreferencia(item)"
                  >mdi-link</v-icon
                >
              </template>
              <span>Generar Link de Pago</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="
                    item.nombreFormaPago == 'Mercado Pago' &&
                    item.estado === 'Pendiente - Link Generado'
                  "
                  medium
                  color="orange"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="enviarLinkMail(item)"
                  >mdi-email</v-icon
                >
              </template>
              <span>Enviar Link por Mail</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="item.estado !== 'Aprobado'"
                  medium
                  v-on="on"
                  color="green"
                  v-bind="attrs"
                  @click="aprobarCobro(item)"
                  >mdi-check-circle</v-icon
                >
              </template>
              <span>Aprobar Pago</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-alert class="mt-4" color="purple" dark outlined v-else>
          No hay cobros realizados para este
          {{ idTurno > 0 ? "turno" : "presupuesto" }}.
        </v-alert>
      </v-card-text>
      <EditarCobro
        :visible="showEditarCobro"
        :idCobro="editedItem.idCobro"
        :idTurnoEditar="editedItem.idTurno"
        :esMercadoPago="esMercadoPago"
        @close="cierraEditarCobro($event)"
      ></EditarCobro>
      <BuscarJugadorTurno
        :visible="showBuscarPaciente"
        @close="showBuscarPaciente = false"
        @seleccionarPaciente="seleccionarPaciente($event)"
      ></BuscarJugadorTurno>
      <EnviarLinkMail
        :visible="showEnviarLinkMail"
        :link="editedItem.linkMercadoPago"
        :paciente="editedItem.idPaciente"
        :pacienteNombre="editedItem.paciente"
        :idProfesional="editedItem.idProfesional"
        @close="
          showEnviarLinkMail = false;
          delta = true;
        "
      ></EnviarLinkMail>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
:deep(.checkbox) {
  .v-input--checkbox {
    margin-top: 0.6rem;
    padding-top: 0;
    &:first-child {
      margin-left: 1rem;
    }
    .v-input--selection-controls__input {
      margin-right: 2px;
    }
  }
}
</style>
<script>
import axios from "@/axios-auth";
import EditarCobro from "./EditarCobro.vue";
import BuscarJugadorTurno from "@/components/Turnos/BuscarJugadorTurno.vue";
import EnviarLinkMail from "./EnviarLinkMail.vue";
import CobrosMixin from "./CobrosMixin.js";
import { showAlert } from "@/utils/toast";
import moment from "moment";

export default {
  props: {
    visible: {
      required: false,
    },
    idTurno: {
      required: false,
      default: 0,
    },
    pacienteTurno: { required: false },
    idProfesional: { required: false },
    idPacienteTurno: { required: false },
    tipoMovimiento: { required: false, default: "cobro" },
    estadoTurno: { required: false, default: 0 },
    celular: { type: String, required: false, default: "" },
    nombrePaciente: { type: String, required: false, default: "" },
  },
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    totalRulesCobros: [
      (v) => !!v || "Dato obligatorio",
      (v) => v >= 0 || "El total debe ser mayor o igual a 0",
    ],
    totalRulesPagos: [
      (v) => !!v || "Dato obligatorio",
      (v) => v > 0 || "El total debe ser mayor a 0",
    ],
    prof: "",
    profsBuscar: [],
    fechaCobro: null,
    paciente: null,
    observaciones: null,
    idPaciente: null,
    total: null,
    listaCobros: [],
    headers: [
      { text: "Fecha", value: "fechaString" },
      { text: "Concepto / Descripción", value: "paciente" },
      { text: "Observaciones", value: "observaciones" },
      { text: "Cancha", value: "nombreCancha" },
      { text: "Forma Pago", value: "nombreFormaPago" },
      { text: "Es Seña", value: "esSena" },
      { text: "Importe", value: "totalString" },
      { text: "Estado", value: "estado" },
      { text: "Acciones", value: "actions" },
    ],
    showEditarCobro: null,
    editedItem: {},
    editedIndex: -1,
    showBuscarPaciente: false,
    formasPago: [],
    formaPago: null,
    showEnviarLinkMail: false,
    delta: false,
    esSena: false,
    esMercadoPago: false,
  }),
  mixins: [CobrosMixin],
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.setearModels();
          if (this.idTurno > 0) this.buscarCobrosTurno();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close", this.delta);
        }
      },
    },
  },
  methods: {
    aprobarCobro(item) {
      this.$swal({
        title: "Aprobar Pago",
        text: "¿Desea aprobar el pago?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosCobro = {
            idCobro: item.idCobro,
            idTurno: item.idTurno,
            esSena: item.esSena,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          };

          let self = this;
          axios
            .post("/Caja/AprobarPago", datosCobro)
            .then((response) => {
              if (response.data === "Ok") {
                self.showAlert({
                  icon: "success",
                  title: "Pago aprobado exitosamente.",
                  vm: self,
                  timer: 2500,
                });
                if (datosCobro.idTurno > 0) {
                  self.$emit("recargarLista");
                  setTimeout(self.buscarCobrosTurno(0), 2600);
                }
              } else {
                self.showAlert({
                  icon: "warning",
                  title: "El pago no pudo ser aprobado.",
                  vm: self,
                  timer: 2500,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El pago no pudo ser aprobado.",
                vm: self,
                timer: 2500,
              });
            });
        }
      });
    },
    enviarLinkMail(item) {
      this.editedIndex = this.listaCobros.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEnviarLinkMail = true;
    },
    generarPreferencia(item) {
      if (!this.$store.state.usuario.institucion.mercadoPagoAccessToken) {
        this.showAlert({
          icon: "warning",
          title: "El complejo no tiene configurado su token de mercado pago.",
          vm: this,
          timer: 2800,
        });
        return;
      }
      this.$swal({
        title: "Generar Link de Pago",
        text: "¿Desea generar el link de pago?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosPreferencia = {
            idCobro: item.idCobro,
            accessToken:
              this.$store.state.usuario.institucion.mercadoPagoAccessToken,
            total: item.total,
            nombreProfesional:
              this.$store.state.usuario.institucion.nombreInstitucion,
          };

          let self = this;
          axios
            .post("/Caja/GenerarPreferencia", datosPreferencia)
            .then((response) => {
              if (response.data === "Ok") {
                self.showAlert({
                  icon: "success",
                  title: "Link de Pago generado exitosamente.",
                  vm: self,
                  timer: 2500,
                });
                if (self.idTurno > 0) {
                  setTimeout(self.buscarCobrosTurno(0), 2600);
                }
              } else {
                self.showAlert({
                  icon: "warning",
                  title: "El Link de Pago no pudo ser generado.",
                  vm: self,
                  timer: 2500,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El Link de Pago no pudo ser generado.",
                vm: self,
                timer: 2500,
              });
            });
        }
      });
    },
    getColor(estado) {
      if (estado == "Aprobado") {
        return "blue";
      }
      if (estado == "Pendiente") {
        return "red";
      }
      if (estado == "Pendiente - Link Generado") {
        return "orange";
      }
    },

    seleccionarPaciente(item) {
      (this.idPaciente = item.idpaciente),
        (this.paciente = item.apellidos + ", " + item.nombres);
      this.showBuscarPaciente = false;
    },
    buscarPaciente() {
      this.showBuscarPaciente = true;
    },
    guardarCobro() {
      if (moment(this.fechaCobro).isBefore(moment("1900-01-01"))) {
        showAlert({
          icon: "warning",
          title: `La fecha del ${
            this.tipoMovimiento === "cobro" ? "cobro" : "pago"
          } debe ser mayor o igual al 01/01/1900.`,
          timer: 2500,
          vm: this,
        });
        return;
      }
      const title =
        this.tipoMovimiento === "cobro" ? "Registrar Cobro" : "Registrar Pago";
      const text =
        this.tipoMovimiento === "cobro"
          ? "¿Desea registrar el cobro?"
          : "¿Desea registrar el pago?";
      this.$swal({
        title: title,
        text: text,
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosCobro = {
            fecha: this.fechaCobro,
            idTurno: this.idTurno,
            estadoTurno: this.estadoTurno,
            idPaciente: this.idPaciente,
            total:
              this.tipoMovimiento === "cobro"
                ? this.total
                : parseFloat(0 - this.total, 2).toString(),
            observaciones: this.observaciones,
            idProfesional: this.prof,
            paciente: this.paciente,
            idFormaPago:
              this.tipoMovimiento === "cobro" ? this.formaPago : null,
            usuario: this.$store.state.usuario.usuario,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            esSena: this.esSena,
          };
          let self = this;
          axios
            .post("/Caja/GuardarCobro", datosCobro)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active"
              )[0].scrollTop = 0;
              const alertTitle =
                self.tipoMovimiento === "cobro"
                  ? "Cobro registrado."
                  : "Pago registrado.";
              self.showAlert({
                icon: "success",
                title: alertTitle,
                vm: self,
                timer: 2000,
              });
              if (self.tipoMovimiento === "cobro" && self.idTurno > 0) {
                this.$swal({
                  title: "Generar Comprobante",
                  text: "¿Desea generar el comprobante de cobro al jugador?",
                  icon: "success",
                  type: "success",
                  showCancelButton: true,
                  background: "#ececec",
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
                }).then((result) => {
                  if (result.value) {
                    this.imprimirCobro(
                      datosCobro,
                      self.pacienteTurno,
                      self.$store.state.usuario.institucion.nombreInstitucion
                    );
                  }
                });
              }
              this.delta = true;
              if (self.idTurno > 0) {
                self.buscarCobrosTurno();
                if (self.estadoTurno === 1) {
                  this.delta = false;
                  self.$emit("recargarLista");
                }
              }
            })
            .catch((error) => {
              const alertTitleError =
                self.tipoMovimiento === "cobro"
                  ? "El cobro no pudo ser registrado."
                  : "El pago no pudo ser registrado.";
              self.showAlert({
                icon: "warning",
                title: alertTitleError,
                vm: this,
                timer: 2000,
              });
            });
        }
        if (
          this.idTurno > 0 &&
          this.$store.state.usuario.institucion.idInstitucion === 170
        ) {
          const self = this;
          axios
            .get("/Turnos/Atendido?", {
              params: {
                idTurno: this.idTurno,
              },
            })
            .then((response) => {
              self.$emit("recargarLista");
            });
        }
      });
    },
    borrarCobro(item) {
      this.$swal({
        title: "Borrar Cobro",
        text: "¿Desea borrar el cobro?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const idCobro = item.idCobro;
          let self = this;
          axios
            .get("/Caja/BorrarCobro?", {
              params: {
                idCobro: idCobro,
                idTurno: item.idTurno,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Cobro borrado.",
                vm: self,
                timer: 2000,
              });
              if (self.idTurno > 0) {
                setTimeout(self.buscarCobrosTurno(), 1700);
              }
              this.delta = true;
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title:
                  "El cobro no puede ser borrado por estar incluído en un cierre de caja.",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    setearModels() {
      this.profsBuscar = [...this.$store.state.usuario.canchas].sort((a, b) =>
        a.nombre.localeCompare(b.nombre)
      );

      this.prof = this.profsBuscar[0].idCancha;

      this.fechaCobro = this.parseDate(
        this.formatDate(this.toISOLocal(new Date()))
      );
      if (this.pacienteTurno != null)
        this.paciente = "Cobro Jugador: " + this.pacienteTurno;
      if (this.idPacienteTurno != null) this.idPaciente = this.idPacienteTurno;

      let self = this;

      axios.get("/Caja/BuscarFormasPago").then((response) => {
        self.formasPago = response.data;
        self.formaPago = self.formasPago[0].idFormaPago;
      });
    },
    buscarCobrosTurno() {
      const filtrosData = {
        idTurno: this.idTurno,
      };

      let self = this;
      axios
        .get("/Caja/BuscarCobrosTurno?", {
          params: {
            idTurno: filtrosData.idTurno,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaCobros = response.data;
          else self.listaCobros = [];
        })
        .catch(function (error) {});
    },
    cierraEditarCobro(delta) {
      this.delta = delta;
      this.esMercadoPago = false;
      this.showEditarCobro = false;

      if (this.idTurno > 0) {
        this.buscarCobrosTurno();
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    vaciarModels() {
      if (this.idTurno == 0) this.paciente = "";
      this.observaciones = "";
      this.total = "";
      this.formaPago = this.formasPago[0].idFormaPago;
      this.esSena = false;
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    editarCobro(item) {
      let self = this;

      if (item.linkMercadoPago) {
        this.esMercadoPago = true;
      }

      axios
        .get("/Caja/ChequearEditarCobro?", {
          params: {
            idCobro: item.idCobro,
          },
        })
        .then((response) => {
          if (response.data == "included") {
            self.showAlert({
              icon: "warning",
              title:
                "El cobro no puede ser modificado por estar incluído en una liquidación.",
              vm: this,
              timer: 2800,
            });
          } else {
            this.tipoMovimiento = item.total >= 0 ? "cobro" : "pago";
            this.editedIndex = this.listaCobros.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditarCobro = true;
          }
        });
    },
  },
  components: {
    EditarCobro,
    BuscarJugadorTurno,
    EnviarLinkMail,
  },
};
</script>
